var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recipes_cards row no-gutters"},_vm._l((_vm.get_AND_Recipies),function(result){return _c('div',{key:result.id,staticClass:"col-lg-3 col-md-4 col-sm-6"},[_c('RecipeCard',{attrs:{"result":result}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }